import React from "react";
import type { DeliverySchedule } from "../../types";
import ModalHeader from "./modalHeader";

interface ApprovalModalProps {
  /** 納入予定実績情報 */
  schedule: DeliverySchedule;
  /** キャンセルボタンハンドラ */
  onClose: () => void;
  /** 確認完了ボタンハンドラ */
  onApprove: () => void;
}

/**
 * 納入実績確認ポップアップ
 * @param props
 * @returns
 */
export const ApprovalModal: React.FC<ApprovalModalProps> = ({ schedule, onClose, onApprove }) => {
  return (
    <div className="modal">
      <div className="content">
        <ModalHeader title="実績確認" onClose={onClose} />

        <div className="approval">
          <table>
            <tr>
              <th></th>
              <th>納入予定</th>
              <th>納入実績</th>
            </tr>
            <tr>
              <td>薬剤名</td>
              <td colSpan={2}>{schedule.chemicalName}</td>
            </tr>
            <tr>
              <td>単位</td>
              <td colSpan={2}>{schedule.planUnit}</td>
            </tr>
            <tr>
              <td>日付</td>
              <td>{schedule.planDate}</td>
              <td>{schedule.resultDate}</td>
            </tr>
            <tr>
              <td>時刻</td>
              <td>{schedule.planTime}</td>
              <td>{schedule.resultTime}</td>
            </tr>
            <tr>
              <td>数量</td>
              <td>{schedule.planVolume}</td>
              <td>{schedule.resultVolume}</td>
            </tr>
          </table>
        </div>

        <div className="parts actions">
          <button onClick={onClose} className="negative">
            キャンセル
          </button>

          <button onClick={onApprove} className="positive">
            確認完了
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalModal;
